import cn from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { getEnharmonicVersion, getNoteOffset, getSolfaName, i18nSolfa, lengthenSolfa } from "../../../common/parameters";
import { IPitch } from "../../../common/types";
import { useUser } from "../../store/user/selectors";
import { parseDo } from "../Score/methods/changeDo";
import getKeyOffset from "../Task/types/Common/getKeyOffset";
import { IProps } from "./interfaces";

import { Container, EqualMark, SolfaName } from "./styles";

const PopupModulation = ({
    nextAcc,
    prevPitch,
    nextPianoNote,
    activeVoiceOctave,
    onClose,
}: IProps) => {
    const { locale } = useIntl();
    const { solfaShort = false, solfaKam = false } = useUser();
    const [isExiting, setIsExiting] = useState(false);
    const [state, setState] = useState(0);

    const getText = () => {
        const parsedNextAcc = parseDo(nextAcc);
        const keyOffset = getKeyOffset(parsedNextAcc.value + 6) + parsedNextAcc.alt;
        let noteOffset = nextPianoNote - (keyOffset + 60);
        let o = Math.floor(noteOffset / 12) as IPitch["o"];
        o = o - activeVoiceOctave as IPitch["o"];
        while (noteOffset < 0) {
            noteOffset += 12;
        }
        let { s, a } = getNoteOffset(noteOffset % 12);
        let nextPitch: IPitch = { o, s, a };
        if ((nextPitch.a === -1 && prevPitch.a === 1) || nextPitch.a === 1 && prevPitch.a === -1) {
            nextPitch = getEnharmonicVersion(nextPitch);
        }
        let prevSolfa = lengthenSolfa(i18nSolfa(getSolfaName(prevPitch as IPitch, locale), locale, solfaKam), locale, solfaShort);
        if (locale === "lt" && prevSolfa.indexOf("b") > -1) {
            prevSolfa = prevSolfa.replace("b", "<i>b</i>");
        }
        let nextSolfa = lengthenSolfa(i18nSolfa(getSolfaName(nextPitch as IPitch, locale), locale, solfaKam), locale, solfaShort);
        if (locale === "lt" && nextSolfa.indexOf("b") > -1) {
            nextSolfa = nextSolfa.replace("b", "<i>b</i>");
        }
        return {
            prevSolfa,
            nextSolfa,
        }
    }
    const text = useRef(getText()).current;

    useEffect(() => {
        let timer = setTimeout(() => {
            setState(1);
            timer = setTimeout(() => {
                setState(2);
                timer = setTimeout(() => {
                    setIsExiting(true);
                    timer = setTimeout(() => {
                        onClose();
                    }, 800)
                }, 1500);
            }, 700);
        }, 700);
        return () => {
            clearTimeout(timer);
        }
    }, [])
    return (
        <Container className={cn({ FadeOut: isExiting })}>
            <SolfaName>
                <span dangerouslySetInnerHTML={{ __html: text.prevSolfa }} />
            </SolfaName>
            <EqualMark style={{ opacity: state > 0 ? 1 : 0}}>=</EqualMark>
            <SolfaName style={{ opacity: state > 1 ? 1 : 0}}>
                <span dangerouslySetInnerHTML={{ __html: text.nextSolfa }} />
            </SolfaName>
        </Container>
    );
};

export default PopupModulation;

